export function log(message?: any, ...optionalParams: any[]) {
    // if (window.console) {
        if (console && console.log) {

            // tslint:disable-next-line:no-console
            console.log(message, optionalParams);
        }
    // }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/debug.ts